import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

class PaymentGPForm extends React.Component {
  static propTypes = {
    hppData: PropTypes.object,
    iframeId: PropTypes.string,
    buttonId: PropTypes.string,
    gpServiceUrl: PropTypes.string.required
  }

  componentDidMount() {
    const { buttonId } = this.props

    document.getElementById(buttonId).click()
  }

  render() {
    const {
      hppData,
      iframeId,
      buttonId,
      gpServiceUrl
    } = this.props

    return (
      <Fragment>
        <form action={gpServiceUrl}
              method="POST"
              target={iframeId}
              style={{ visibility: 'hidden' }} >
          {Object.keys(hppData).map(key => {
            return (
              <input type="hidden" name={key} value={hppData[key]} />
            )
          })}

          <input id={buttonId} type="submit" value="Click To Pay" />
        </form>
      </Fragment>
    )
  }
}


export default PaymentGPForm
